import React, { Component } from 'react';
import { connect } from 'react-redux';
import Ink from 'react-ink';
import { bindActionCreators } from 'redux';
import { CSSTransitionGroup } from 'react-transition-group';

import * as AppActions from '../app/AppActions';
import FloorplanContainer from './FloorplanContainer';
import ReactGA from 'react-ga';
import './Style';

class FloorplanFullscreenContainer extends Component {
    constructor() {
        super();

        this.floorplanCloseOnClick = this.floorplanCloseOnClick.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);

        this.state = {
          windowHeight: window.innerHeight,
          lastTouchEnd: 0
        }
    }

    componentDidMount() {
        // ReactGA.pageview(window.location.pathname);

        const app = document.getElementById('app');

        window.addEventListener('resize', this.onResize, false);
        app.addEventListener('gesturestart', this.preventDefault, false);
        app.addEventListener('touchmove', this.preventDefault, false);
        app.addEventListener('touchend', this.onTouchEnd, false);
        document.body.classList.add("fixed");
    }

    componentWillUnmount() {
        const app = document.getElementById('app');

        window.removeEventListener('resize', this.onResize, false);
        app.removeEventListener('gesturestart', this.preventDefault, false);
        app.removeEventListener('touchmove', this.preventDefault, false);
        app.removeEventListener('touchend', this.onTouchEnd, false);
        document.body.classList.remove("fixed");
    }

    floorplanCloseOnClick() {
        this.props.appActions.redirectToHome();
    }

    onResize() {
        this.setState({windowHeight: window.innerHeight});
    }

    onTouchEnd(e) {
        let now = (new Date()).getTime();
        if (now - this.state.lastTouchEnd <= 300) {
            e.preventDefault();
        }
        this.setState({ lastTouchEnd:now });
    }

    preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault)
            e.preventDefault();
        e.returnValue = false;
    }

    render() {
        const height = this.state.windowHeight;

        return (
            <div>
                <CSSTransitionGroup
                    transitionName="opacityAnim"
                    transitionAppear={true}
                    transitionAppearTimeout={500}
                    transitionEnter={false}
                    transitionLeave={false}>
                    <div className="floorplan-fullscreen" key={'floorplan'} style={{height: height}}>
                        <div className="floorplan-header">
                            <h2>interactive floor plan</h2>
                            <div className="floorplan-close">
                                <button className="btn" onClick={this.floorplanCloseOnClick}>
                                    <i className="fa fa-times-circle"></i>
                                    <Ink />
                                </button>
                            </div>
                        </div>
                        <div className="floorplan-body">
                            <FloorplanContainer />
                        </div>
                    </div>
                </CSSTransitionGroup>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => ({
    appActions: bindActionCreators(AppActions, dispatch)
});


export default connect(mapStateToProps, mapDispatchToProps)(FloorplanFullscreenContainer);
